import React from "react"
import { v4 } from 'uuid'
import { Link } from "gatsby"
import { Section, SectionPageTitle, SectionBanner, BreadCrumb } from "../components/section"
import Layout from "../components/layout"
import SEO from "../components/seo"
import FadeDrop from "../components/FadeDrop"
import FaqBanner from "../images/faq-banner.jpg"


const FaqPage = ({ data, location }) => {
  const pageData = data.allContentfulFaqsReviewsPage.edges[0]
  const faqsData = data.allContentfulFaq
  return(
    <Layout location={location}>
      <SEO title={pageData.node.metaTitle} description={pageData.node.metaDescription}/>
      <SectionBanner bgImg={`url(${FaqBanner})`}>
        <div className="container">
          <BreadCrumb><Link to='/'>Home</Link>/<span>FAQ</span></BreadCrumb>   
          <SectionPageTitle mt="30px" mb="0px" textAlign="center">
            {pageData.node.heroTitle}
          </SectionPageTitle>
        </div>
      </SectionBanner>
      <Section pt="100px" pb="90px" xpt="60px" xpb="60px">       
        <div className="container">
          {
            faqsData.edges.map(item=>{
              return(
                <FadeDrop data={item.node} key={v4()} />      
              )
            })
          }
        </div>
      </Section>    
    </Layout>
  )
}

export default FaqPage

export const pageQuery = graphql`
  query FaqPageQuery {
    allContentfulFaqsReviewsPage(filter: {identify: {eq: "Faqs"}}) {
      edges {
        node {
          metaTitle
          metaDescription
          heroTitle
          heroBackground {
            fluid {
              aspectRatio
              base64
              src
              srcSet
              srcSetWebp
              srcWebp
            }
          }
        }
      }
    }
    allContentfulFaq {
      edges {
        node {
          question
          answer {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
  }
`

